// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"18":"product","130":"basket","443":"about","449":"notFound","535":"login","663":"guarantee","893":"products"}[chunkId] + "." + {"18":"91aa5641","130":"a2386313","443":"803f4e0c","449":"7101b25a","535":"1c5654a4","663":"411899ea","893":"42a03f09"}[chunkId] + ".js";
};